// Backend #657 slice 3: the Carrier admin's view of Email.Api's send queue, read through the
// BFF's api/EmailMessages pass-through (paged #648 envelope). The BFF serializes enums as
// camelCase strings (JsonStringEnumConverter), so the status travels as 'pending' … 'failed'.
export const EmailMessageStatusConstants = {
  Pending: 'pending',
  Sending: 'sending',
  Sent: 'sent',
  Failed: 'failed',
} as const;

export type EmailMessageStatus =
  (typeof EmailMessageStatusConstants)[keyof typeof EmailMessageStatusConstants];

export const EmailMessageStatusDisplayNames: Record<string, string> = {
  [EmailMessageStatusConstants.Pending]: $localize`Wartend`,
  [EmailMessageStatusConstants.Sending]: $localize`Wird gesendet`,
  [EmailMessageStatusConstants.Sent]: $localize`Gesendet`,
  [EmailMessageStatusConstants.Failed]: $localize`Fehlgeschlagen`,
};

// The rendered body never leaves Email.Api (it carries activation / reset links).
export interface EmailMessage {
  id: string;
  recipientEmail: string;
  templateKey: string;
  subject: string;
  status: EmailMessageStatus;
  attemptCount: number;
  nextAttemptAt?: string | null;
  lastError?: string | null;
  correlationId?: string | null;
  requestedBy?: string | null;
  createdAt: string;
  sentAt?: string | null;
  completedAt?: string | null;
}

// All filters optional and AND-combined server-side; recipient is a contains-match.
export interface EmailMessageFilter {
  status?: EmailMessageStatus | null;
  recipient?: string | null;
  templateKey?: string | null;
  correlationId?: string | null;
}
